import React, { createContext, useState, useEffect, useContext } from 'react';
import client from '../api/client';
import { jwtDecode } from 'jwt-decode'; // Need to install jwt-decode or just check existence

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            // Ideally verify token with backend, for now decode or just assume logged in
            try {
                const decoded = jwtDecode(token); // You'd need to install jwt-decode
                // or just set user based on token existence for now if minimal
                setUser({ email: decoded.sub });
            } catch (e) {
                console.error("Invalid token", e);
                localStorage.removeItem('token');
            }
        }
        setLoading(false);
    }, []);

    const login = async (email, password) => {
        const formData = new FormData();
        formData.append('username', email);
        formData.append('password', password);

        const response = await client.post('/auth/token', formData);
        const { access_token } = response.data;
        localStorage.setItem('token', access_token);
        setUser({ email });
        return true;
    };

    const signup = async (email, password, fullName) => {
        await client.post('/auth/signup', { email, password, full_name: fullName });
        return true; // Then user needs to login
    };

    const logout = () => {
        localStorage.removeItem('token');
        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ user, login, signup, logout, loading }}>
            {!loading && children}
        </AuthContext.Provider>
    );
};
